<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Liz Sorora was born in a small city of Albania and was raised in a village in Greece. Liz has grown to be an education major, with psychological interests, as well as a huge passion for literature, arts and philosophy. If she isn’t spending her time writing, then you most likely will find her painting and listening to music. Creating for her is a means to reach out to someone, comfort them, embrace them and entertain them. She is a firm believer that there’re many ways individuals can learn and thus she tries to embody in her writings life lessons.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ac2810f0